export default "__VITE_ASSET__a74c0b66__"